import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, FormGroup, ControlLabel } from "react-bootstrap";
import moment from "moment";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import Button from 'Admin/elements/CustomButton/CustomButton.jsx';
import {
    Modal
} from 'react-bootstrap';
import { nextVisitAction, holidayListAction } from "Front/actions/home";
import { next_visit_days } from "Front/variables/Variables.jsx";
import CalendarIc from "../../../../assets/img/icons/calendar_white.png"

const NextVisitPopup = ({ nextVisitData, onDismissNextVisit, setShowNextVisitModal, showNextVisitModal, setNextVisitDate, nextVisitDate }) => {
    const dispatch = useDispatch();
    console.log(nextVisitData, "-------------nextVisitData")
    const HolidayList = useSelector((state) => state.home.HolidayList);
    const isHolidayList = useSelector((state) => state.home.isHolidayList);
    const NextVisitMessage = useSelector((state) => state.home.NextVisit);
    const isNextVisit = useSelector((state) => state.home.isNextVisit);
    const isNextVisitError = useSelector((state) => state.home.isNextVisitError);

    const [date, setDate] = useState(nextVisitData.nextDate ? new Date(nextVisitData.nextDate) : "");
    const [numberOfDays, setNumberOfDays] = useState(calculateNumberOfDay(nextVisitData.nextDate));
    const [erroMsg, setErroMsg] = useState("");
    const [holidayList, setHolidayList] = useState([]);
    const [disabledDays, setDisabledDays] = useState([]);
    const [formData, setFormData] = useState({
        id: nextVisitData.id,
        next_visit_date: nextVisitData.nextDate
            ? moment(nextVisitData.nextDate).format("YYYY-MM-DD")
            : null,
        patient_id: nextVisitData.pId,
        notificationDay: localStorage.getItem("patientNotificationDay")
            ? Number(localStorage.getItem("patientNotificationDay"))
            : 1,
    });
    const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false)

    const handleDaySelect = (day, modifiers = {}) => {
        if (modifiers.disabled) return;

        const selectedDate = moment(day).format("YYYY-MM-DD");
        const today = moment().format("YYYY-MM-DD");

        if (selectedDate >= today) {
            const newDate = new Date(day);
            setDate(newDate);
            setFormData((prev) => ({
                ...prev,
                next_visit_date: moment(newDate).format("YYYY-MM-DD"),
            }));
        }
    };

    const handleNumberChange = (e) => {
        const value = e.target.value;
        const rawDate = moment().add(value, "days");
        const finalDate = checkNextVisit(rawDate);

        setDate(new Date(finalDate));
        setNumberOfDays(value);
        setErroMsg("");

        setFormData((prev) => ({
            ...prev,
            next_visit_date: moment(finalDate).format("YYYY-MM-DD"),
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.next_visit_date) {
            setErroMsg("Please select next visit date.");
            return;
        }
        setIsSaveButtonClicked(true)
        dispatch(nextVisitAction(formData));
    };

    const renderDay = (day) => {
        const formattedDate = moment(day).format("YYYY-MM-DD");
        const today = moment().format("YYYY-MM-DD");

        let styleClass = "gray";
        const isToday = formattedDate === today;
        const isHoliday = disabledDays.some((d) => moment(d).format("YYYY-MM-DD") === formattedDate);

        if (isHoliday) styleClass = "red-bg";
        else if (isToday) styleClass = "green-bg";

        return (
            <div className={styleClass} style={{ height: 30, width: 30, borderRadius: 15 }}>
                <div style={{ paddingTop: 5 }}>{day.getDate()}</div>
            </div>
        );
    };

    const handleClose = () => {
        setDate("")
        setNumberOfDays("")
        setFormData({})
        setShowNextVisitModal(false)
    }

    useEffect(() => {
        dispatch(holidayListAction());
    }, []);

    useEffect(() => {
        if (isHolidayList && HolidayList) {
            const list = HolidayList.list || [];
            setHolidayList(list);
            const newDisabledDays = [];
            list.forEach((item) => {
                item.calendarDate.forEach((d) => newDisabledDays.push(new Date(d)));
            });
            setDisabledDays(newDisabledDays);
        }
    }, [isHolidayList]);

    useEffect(() => {
        if (
            isSaveButtonClicked &&
            isNextVisit &&
            NextVisitMessage?.status === "Success" &&
            NextVisitMessage?.msg &&
            formData.first_name !== ""
        ) {
            setNextVisitDate(moment(formData?.next_visit_date).format("DD-MMM-YYYY"))
            setDate("")
            setNumberOfDays("")
            setFormData({})
            onDismissNextVisit();
        }

        if (isNextVisitError && NextVisitMessage?.errors) {
            NextVisitMessage.errors.forEach((err) => {
                setErroMsg(err.msg);
            });
        }
    }, [isSaveButtonClicked, isNextVisit, isNextVisitError]);

    useEffect(() => {
        if (showNextVisitModal) {
            const finalDate = nextVisitDate
            console.log(finalDate, nextVisitDate, nextVisitData?.nextDate, "---------finalDate")
            setDate(finalDate ? new Date(finalDate) : "")
            setNumberOfDays(calculateNumberOfDay(finalDate))
            setErroMsg("")
            setHolidayList([])
            setDisabledDays([])
            setFormData({
                id: nextVisitData.id,
                next_visit_date: finalDate
                    ? moment(finalDate).format("YYYY-MM-DD")
                    : null,
                patient_id: nextVisitData.pId,
                notificationDay: localStorage.getItem("patientNotificationDay")
                    ? Number(localStorage.getItem("patientNotificationDay"))
                    : 1,
            })
            setIsSaveButtonClicked(false)
        }
    }, [showNextVisitModal])

    return (
        <span>
            <Button type="button" id="btnNextVisit" onClick={e => setShowNextVisitModal(true)} className="btn btn-fill btn-primary">Next Visit Date</Button>
            {/* <span>
                <img onClick={e => setShowNextVisitModal(true)} style={{ width: "20px" }} className="table-action-ic" src={CalendarIc} alt="" />
            </span> */}
            <Modal
                backdrop="static"
                className="pa-next-visit"
                show={showNextVisitModal}
                onHide={() => handleClose()}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Next visit date
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share ">
                    <div>
                        <Row>
                            <Col sm={6} className="next-calender">
                                <DayPicker
                                    month={new Date(date || moment().format("YYYY-MM-DD"))}
                                    selectedDays={date}
                                    onDayClick={handleDaySelect}
                                    renderDay={renderDay}
                                    disabledDays={[...disabledDays, { before: new Date() }]}
                                />
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Col componentClass={ControlLabel}>Next Visit Date</Col>
                                    <Col>
                                        <select className="form-control" value={numberOfDays} onChange={handleNumberChange}>
                                            <option value="">Select</option>
                                            {next_visit_days.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                        <span className="errorMsg">{erroMsg}</span>
                                        <h4 className="mt-10">
                                            {formData.next_visit_date ? moment(formData.next_visit_date).format("DD-MM-YYYY") : ""}
                                        </h4>
                                    </Col>
                                </FormGroup>
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={isSaveButtonClicked}
                                    className="visit-btn btn-fill btn-wd btn btn-primary"
                                >
                                    Save{" "}
                                    {isSaveButtonClicked && <i class="fa fa-spinner fa-spin"></i>}
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        </span>
    );
};

// Helpers
const calculateNumberOfDay = (date) => {
    return date ? moment(date).diff(moment(), "days") + 1 : 0;
};

const checkNextVisit = (date) => {
    const weekOff = JSON.parse(localStorage.getItem("is_week_off")) || [];
    if (date.day() === 0 || weekOff.some((d) => d.day === date.day())) {
        return checkNextVisit(moment(date).add(1, "days"));
    }

    const holidayList = JSON.parse(localStorage.getItem("holiday_date")) || [];
    const formattedDate = moment(date).format("YYYY-MM-DD");
    if (holidayList.includes(formattedDate)) {
        return checkNextVisit(moment(date).add(1, "days"));
    }

    return date;
};

export default NextVisitPopup;
